/* eslint-disable no-mixed-operators */
import StarRatings from "component/design-system/StarRatings";
import LoaderSkeleton from "component/loader-skeleton/LoaderSkeleton";
import { RootState } from "interfaces/generics.type";
import { useTranslation } from "next-i18next";
import Image from "next/legacy/image";
import Link from "next/link";
import { useRouter } from "next/router";
import { useSelector } from "react-redux";
import HideIf from "util/HideIf";
import { getRelativeImagePath } from "util/helper/getRelativeImagePath";
import { isBusinessHP } from "util/helper/helper";
import { numberFormat } from "util/helper/numberFormat";
import styles from "./HeaderCarousel.module.scss";
const bannerData = require("resources/json/header-carousel.json");

function HeaderCarousel() {
  const { t } = useTranslation("common");

  const { asPath } = useRouter();
  const isBusinessPage = isBusinessHP(asPath);
  const { businessCustomer, averageRating, totalReviewCount } = useSelector((state: RootState) => state.authenticationState);

  let renderRatingComponent = (
    <LoaderSkeleton width={126.2} className={styles.loader_skeleton} />
  );
  // Change ratings to 4.5 bcz due to sitejabber bug, ratings are dropped
  renderRatingComponent = (
    <div className={styles.review_content}>
      {t("reviews_rating", { starRating: averageRating, reviewCount: numberFormat(totalReviewCount) }) }
    </div>
  );

  if (isBusinessPage || businessCustomer) {
    return null;
  }

  return (
    <div className={styles.container}>
      <div className={styles.subContainer}>
        {bannerData.map((data: any, index: number) => (
          <div className={styles.eachItem} key={data.alt}>
            <Link
              href={data.link}
              className={`${styles.text} d-flex align-items-center`}
              target="_blank"
              aria-label={data.alt}
              title={data.alt}
            >

              <HideIf show={index === 1}>

                <div className="d-flex align-items-center m-r-5">
                  <div className="m-r-5">
                    <StarRatings
                      rating={4.6}
                      height={15}
                      width={100}
                      filled
                    />
                  </div>
                  {" "}
                  {renderRatingComponent}

                </div>
                <div className="p-r-5">{t(data.tagline)}</div>
              </HideIf>
              <HideIf show={index !== 1}>
                <div className="p-r-5 visible-md visible-lg">{t(data.tagline)}</div>
              </HideIf>

            </Link>
            <HideIf show={index === 1}>
              <Link
                href={data.imgLink}
                className={styles.bbb_image}
                target="_blank"
                aria-label={data.alt}
                title={data.alt}
              >

                <div className={styles.img}>
                  <Image
                    unoptimized
                    layout="intrinsic"
                    alt={data.alt}
                    title={data.alt}
                    src={getRelativeImagePath(data.img)}
                    width={140}
                    height={30}
                  />
                </div>

              </Link>
            </HideIf>
          </div>
        ))}
      </div>
    </div>
  );
}

export default HeaderCarousel;
